import {
    Avatar,
    Badge,
    Box,
    Button,
    Flex,
    Heading,
    HStack,
    Menu,
    MenuButton,
    MenuDivider,
    MenuItem,
    MenuList,
    Spacer,
    Text,
    VStack,
} from "@chakra-ui/react";
import { FaRocket } from "react-icons/fa";
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useRateUsageContext } from "../hooks/RateUsageContext";

const Navbar = () => {
    const { user, logout } = useAuth();
    const { getUsageEntry } = useRateUsageContext();
    const articleUsage = getUsageEntry("ArticlesPerDay");
    const ratingUsage = getUsageEntry("RateLimitPerDay");

    return (
        <Box
            as="header"
            bg="white"
            px={{ base: 4, md: 6 }}
            py={3}
            borderBottom="1px solid"
            borderColor="gray.200"
            shadow="sm"
            position="sticky"
            top={0}
            zIndex={10}
        >
            <Flex alignItems="center">
                <Heading
                    as={RouterLink}
                    to="/"
                    size="md"
                    _hover={{ textDecoration: "none" }}
                >
                    NewsReader
                </Heading>

                <Spacer />

                {user ? (
                    <HStack spacing={{ base: 2, md: 4 }}>
                        <Flex
                            as={RouterLink}
                            to="/pricing"
                            align="center"
                            px={{ base: 2, md: 4 }}
                            py={1.5}
                            bgGradient="linear(to-r, blue.50, blue.100)"
                            border="1px solid"
                            borderColor="blue.200"
                            borderRadius="full"
                            _hover={{
                                bgGradient:
                                    "linear(to-r, blue.100, blue.200)",
                                boxShadow: "md",
                                textDecoration: "none",
                            }}
                            transition="all 0.2s ease"
                        >
                            <VStack
                                spacing={0}
                                align="flex-start"
                                mr={2}
                                display={{ base: "none", md: "flex" }}
                            >
                                {articleUsage && (
                                    <Text fontSize="xs" color="blue.700">
                                        Articles: {articleUsage.used} /{" "}
                                        {articleUsage.limit}
                                    </Text>
                                )}
                                {ratingUsage && (
                                    <Text fontSize="xs" color="blue.700">
                                        Ratings: {ratingUsage.used} /{" "}
                                        {ratingUsage.limit}
                                    </Text>
                                )}
                            </VStack>

                            <Badge
                                colorScheme="blue"
                                variant="subtle"
                                fontSize="xs"
                            >
                                Upgrade
                            </Badge>
                            <FaRocket
                                aria-hidden
                                style={{
                                    marginLeft: "4px",
                                    color: "#3182CE",
                                }}
                            />
                        </Flex>

                        <Menu>
                            <MenuButton
                                aria-label={`Open account menu for ${user.firstName} ${user.lastName}`}
                            >
                                <Avatar
                                    name={`${user.firstName} ${user.lastName}`}
                                    size="sm"
                                />
                            </MenuButton>
                            <MenuList>
                                <Box px={3} pt={2} fontWeight="medium">
                                    {user.firstName} {user.lastName}
                                </Box>
                                <MenuDivider />
                                <MenuItem as={RouterLink} to="/profile">
                                    Profile
                                </MenuItem>
                                <MenuItem as={RouterLink} to="/saved">
                                    Saved articles
                                </MenuItem>
                                <MenuItem as={RouterLink} to="/history">
                                    Reading history
                                </MenuItem>
                                {user.roles.includes("ROLE_ADMIN") && (
                                    <MenuItem as={RouterLink} to="/admin/news">
                                        Editorial workspace
                                    </MenuItem>
                                )}
                                <MenuItem onClick={logout}>Logout</MenuItem>
                            </MenuList>
                        </Menu>
                    </HStack>
                ) : (
                    <Button
                        as={RouterLink}
                        to="/login"
                        size="sm"
                        colorScheme="blue"
                    >
                        Login
                    </Button>
                )}
            </Flex>
        </Box>
    );
};

export default Navbar;
